export default "__VITE_ASSET__CRYPNcWN__"